import React from 'react';
import PropTypes from 'prop-types';

import Image from '@nerdwallet/react-image';
import Title from '@nerdwallet/react-typography';
import Button from '@nerdwallet/react-button';
import styles from './login.module.less';

const Login = ({
  onSuccess,
  isSignedIn,
  loginModalImgOverride,
  loginModalCopyOverride,
  loginPageCopyOverride,
}) => {
  let showFlowConfig;

  if (loginModalImgOverride || loginModalCopyOverride) {
    const slideConfig = {};
    if (loginModalCopyOverride) slideConfig.copy = loginModalCopyOverride;
    if (loginModalImgOverride) slideConfig.image = loginModalImgOverride;

    showFlowConfig = {
      slides: [slideConfig],
    };
  } else {
    showFlowConfig = {};
  }

  return (
    <div className={styles.login__cont}>
      <Image
        className={styles.login__img}
        src="https://www.nerdwallet.com/cdn/brand-site/NW_logo_vert.png"
        alt="NerdWallet Brand"
        backgroundColor="transparent"
        naturalHeight={318}
        naturalWidth={289}
      />
      <Title size="3">
        {loginPageCopyOverride ||
          'You must be signed in with the appropriate credentials to view this page'}
      </Title>
      {!isSignedIn ? (
        <div className={styles.login__btn}>
          <Button
            onClick={() =>
              window.nwapi.ui.showAuthDialog({
                flow: 'basic',
                version: 1,
                onSuccess,
                flowConfig: showFlowConfig,
              })
            }
          >
            SIGN IN OR CREATE ACCOUNT
          </Button>
        </div>
      ) : null}
    </div>
  );
};

Login.displayName = 'Login';

Login.propTypes = {
  onSuccess: PropTypes.string,
  isSignedIn: PropTypes.bool,
  loginModalImgOverride: PropTypes.string,
  loginModalCopyOverride: PropTypes.string,
  loginPageCopyOverride: PropTypes.string,
};

export default Login;
